import { queryOptions, useQuery } from "@tanstack/react-query";

import { Chain } from "@nitro-ape/shared/models/enums/chain";
import { Pool } from "@nitro-ape/shared/models/pool";
import { z } from "zod";
import { QueryConfig } from "../../../lib/query-config";
import api from "../../../platform/api/api";

const PoolByTokenSchema = z.object({
  poolId: z.string(),
  chain: z.enum(Chain),
});

export type PoolByToken = z.infer<typeof PoolByTokenSchema>;

export const getPoolFromToken = async ({
  tokenId,
}: {
  tokenId: string;
}): Promise<PoolByToken | null> => {
  try {
    const { data } = await api.get<Pool>(`/pools/token/${tokenId}`);
    return PoolByTokenSchema.parse(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getPoolFromTokenQueryOptions = (tokenId: string | null) => {
  return queryOptions({
    queryKey: ["pool", "token", tokenId],
    queryFn: () => getPoolFromToken({ tokenId: tokenId! }),
    enabled: !!tokenId,
  });
};

type UsePoolFromTokenOptions<TData = Pool | null> = {
  queryConfig?: QueryConfig<typeof getPoolFromToken>;
  select?: (data: PoolByToken | null) => TData;
};

export const usePoolFromToken = <TData = PoolByToken | null>({
  tokenId,
  queryConfig,
  select,
}: UsePoolFromTokenOptions<TData> & {
  tokenId: string | null;
}) => {
  const query = useQuery({
    ...getPoolFromTokenQueryOptions(tokenId),
    ...queryConfig,
    select,
  });

  return query;
};
